import { connect } from "react-redux";
import OvToggleFilterPanel from "./OvToggleFilterPanel";
import { setOverviewFilterVisibility } from "./actions/overviewParams";

const mapStateToProps = (state, ownProps) => {
  return {
    filterPanelVisible: state.ui.overviewFiltersVisible
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onVisibilityChange: visible => {
      dispatch(setOverviewFilterVisibility(visible));
    }
  };
};

const OvToggleFilterPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(OvToggleFilterPanel);

export default OvToggleFilterPanelContainer;



// WEBPACK FOOTER //
// ./src/OvToggleFilterPanelContainer.js